import * as _ from "lodash";
import { Components } from "formiojs";

const DateComponent  = Components.components.datetime;

export default class MiproPatientDateOfBirth  extends DateComponent  {

    static schema() {
        return DateComponent.schema({
            type: "miproPatientDateOfBirth",
            label: "Patient DOB",
            key: "dbo.mipro.miproPatientDateOfBirth",
            placeholder: "Enter Date of Birth", 
            format: "dd/MM/yyyy", 

            disableWeekends: false,
            disableWeekdays: false,
            minDate: null,
            maxDate: null,
            input: true,
            customClass: "",
            "enableTime": false,
        });
    }

    init() {
        super.init();
    }

    static get builderInfo() {
        return {
            title: "Patient DOB",
            group: "basic",
            icon: "calendar",
            weight: 70,
            schema: MiproPatientDateOfBirth.schema(),            
        };
    }
}

Components.addComponent("miproPatientDateOfBirth", MiproPatientDateOfBirth);